// src/pages/Produtos/profiles/bobina.js
export const bobinaProfile = {
    id: 'bobina',
    labelForm: 'Gestão de Bobinas',
    tabs: {
        cabecalho: { enabled: true },
        industria: { enabled: true },
        materiaPrima: { enabled: true },
        modoProducao: { enabled: true },
        embalagens: { enabled: true },
        caracteristicas: { enabled: true },
        bens: { enabled: false },
        mobilia: { enabled: false },
        imagens: { enabled: true },
    },
    uiTabs: {
        cabecalho: {
            titles: { grid: 'detalhes do cadastro da bobina' },
            labels: { grid: 'Informções da bobina' },
            show: {
                //1ª div cabeçalho
                empresa: true,
                compra: false,
                venda: true,
                locavel: false,
                industria: true,
                servico: false,
            },
        },
        embalagem: {
            titles: { grid: 'embalagens aplicadas a bobina' },
            labels: {},
        },
    },
    parametros: {
        defaultsProduto: {
            isBobina: true,
            industria: true,
            venda: false, // você comentou: bobina é produto específico para indústria
        },
        sanitize: {
            keepChildren: ['Empresa', 'NCM', 'Fabricante', 'produtoEmbalagens', 'produtoImagens'],
        },
    },
};
